export class FilterCollapseStateManager {

  private static _instance: FilterCollapseStateManager;
  public static get instance(): FilterCollapseStateManager {
    if (!FilterCollapseStateManager._instance) {
      FilterCollapseStateManager._instance = new FilterCollapseStateManager();
    }

    return FilterCollapseStateManager._instance;
  }

  private collapseStateMap: Map<string, boolean>;

  private constructor() {
    this.collapseStateMap = new Map<string, boolean>();
    this.setDefaultState();
  }

  private setDefaultState(): void {
    this.collapseStateMap.set('category', true);
  }

  update(filterKey: string, expanded: boolean): void {
    this.collapseStateMap.set(filterKey, expanded);
  }

  isExpanded(filterKey: string, defaultValue: boolean = true): boolean {
    if (!this.collapseStateMap.has(filterKey)) {
      this.collapseStateMap.set(filterKey, defaultValue);
    }

    return this.collapseStateMap.get(filterKey);
  }

}
